import React from 'react';

/** The tab bar under a screen header; `activeClass` carries the screen's accent colour */
const TabStrip = ({ tabs, activeTab, onChange, activeClass }) => (
  <div className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 sticky top-0 z-10 shadow-sm">
    <div className="flex px-2">
      {tabs.map((tab) => {
        const TabIcon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`flex-1 flex flex-col items-center gap-1 px-2 py-3 border-b-2 transition-colors ${activeTab === tab.id ? activeClass : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
          >
            <TabIcon size={18} />
            <span className="font-medium text-xs">{tab.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);

export default TabStrip;
